<div #scrollContainer>
    <dx-responsive-box width="100%" height="100%">
        <dxi-row></dxi-row>
        <dxi-col></dxi-col>

        <dxi-item>
            <dxi-location [row]="0" [col]="0"></dxi-location>
            <div class="scrollview-container cc-scrollview-container">
                <dx-scroll-view
                    #scrollView
                    id="scrollview"
                    [scrollByContent]="scrollByContent"
                    [scrollByThumb]="scrollByThumb"
                >
                    <div class="welcome-message-container">
                        <div>
                            Welcome to the CiraNet
                            <span class="emphasis">Management/Board Portal</span>
                            powered by CiraConnect. The Management / Board Portal is the most comprehensive application
                            available empowering community managers and board and committee members in managing the
                            business affairs of common interest realty associations including homeowner associations
                            (HOAs), condominium associations, cooperatives, luxury high-rises, municipal utility
                            districts and large master planned communities.
                            <br />
                            <br />
                            Logging in will let you access your community or portfolio of communities
                            <br />
                            <br />
                            Unable to access your account or need assistance? Please contact us at
                            <strong>
                                <a href="mailto:{{ contactEmail }}">{{ contactEmail }}</a>
                            </strong>
                            or call
                            <strong>
                                <a href="tel:{{ contactUsPhone }}">{{ contactUsPhoneDisplayText }}</a>
                            </strong>
                            .
                        </div>
                    </div>
                </dx-scroll-view>
            </div>
        </dxi-item>
    </dx-responsive-box>
</div>
